export const SEASON_PRIZE_POOL = 3_000;
export const SEASON_PRIZES = [
    { from: 1, through: 1, diamonds: 1_000 },
    { from: 2, through: 2, diamonds: 400 },
    { from: 3, through: 3, diamonds: 250 },
    { from: 4, through: 4, diamonds: 150 },
    { from: 5, through: 5, diamonds: 100 },
    { from: 6, through: 10, diamonds: 60 },
    { from: 11, through: 20, diamonds: 30 },
    { from: 21, through: 40, diamonds: 17 },
    { from: 41, through: 50, diamonds: 16 },
];
/** The new pool applies from autumn 2026; never reprice a closed season. */
export const seasonRewardForRank = (rank, startsAt) => {
    if (!Number.isInteger(rank) || rank < 1)
        return 0;
    if (startsAt < new Date('2026-08-31T21:00:00.000Z')) {
        if (rank === 1)
            return 100;
        if (rank <= 3)
            return 50;
        if (rank <= 10)
            return 25;
        return rank <= 25 ? 10 : 0;
    }
    return SEASON_PRIZES.find((tier) => rank >= tier.from && rank <= tier.through)?.diamonds ?? 0;
};
/** Ranked scores come from the server's complete, tie-broken season standings. */
export const seasonPrizeForecast = (rankedRp, currentIndex, startsAt) => {
    const participating = currentIndex >= 0 && currentIndex < rankedRp.length;
    const rank = participating ? currentIndex + 1 : rankedRp.length + 1;
    const currentReward = participating ? seasonRewardForRank(rank, startsAt) : 0;
    const currentRp = participating ? rankedRp[currentIndex] : 0;
    for (let target = Math.min(participating ? rank - 1 : rank, 50); target >= 1; target -= 1) {
        const reward = seasonRewardForRank(target, startsAt);
        if (reward > currentReward)
            return {
                currentReward,
                next: {
                    rank: target,
                    reward,
                    rpNeeded: Math.max(1, (rankedRp[target - 1] ?? 0) + 1 - currentRp),
                },
            };
    }
    if (!participating)
        return {
            currentReward: 0,
            next: { rank: 1, reward: seasonRewardForRank(1, startsAt), rpNeeded: 1 },
        };
    return { currentReward, next: null };
};
const definitions = {
    winter: {
        name: 'Зимний кубок',
        subtitle: 'Новый год · День защитника Отечества',
        accent: '#67e8f9',
        icon: '❄️',
    },
    spring: {
        name: 'Весенний сезон',
        subtitle: 'Весна · День Победы',
        accent: '#4ade80',
        icon: '🌿',
    },
    summer: {
        name: 'Кубок лета',
        subtitle: 'Летние арены · День России',
        accent: '#fbbf24',
        icon: '☀️',
    },
    autumn: {
        name: 'Осенний чемпионат',
        subtitle: 'Осенние арены · День народного единства',
        accent: '#fb923c',
        icon: '🍁',
    },
};
export const gameSeasonAt = (now = new Date()) => {
    const shifted = new Date(now.getTime() + 3 * 3_600_000);
    const year = shifted.getUTCFullYear();
    const month = shifted.getUTCMonth();
    const theme = month <= 1 || month === 11
        ? 'winter'
        : month <= 4
            ? 'spring'
            : month <= 7
                ? 'summer'
                : 'autumn';
    const startMonth = theme === 'winter'
        ? month === 11
            ? 11
            : -1
        : theme === 'spring'
            ? 2
            : theme === 'summer'
                ? 5
                : 8;
    const startYear = startMonth === -1 ? year - 1 : year;
    const normalizedStartMonth = startMonth === -1 ? 11 : startMonth;
    const startsAt = new Date(Date.UTC(startYear, normalizedStartMonth, 1) - 3 * 3_600_000);
    const endsAt = new Date(Date.UTC(startYear, normalizedStartMonth + 3, 1) - 3 * 3_600_000);
    return { key: `${startYear}-${theme}`, ...definitions[theme], theme, startsAt, endsAt };
};
export const previousGameSeason = (now = new Date()) => {
    const current = gameSeasonAt(now);
    return gameSeasonAt(new Date(current.startsAt.getTime() - 1));
};
